// extracted by mini-css-extract-plugin
export default {"container":"error-message_container__PVHbT","fontIconWrapper":"error-message_fontIconWrapper__SOmay","messageText":"error-message_messageText__CIFHi"};